var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quantity-input" },
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "u-sr-only", attrs: { for: _vm.idForInput } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _c(
        "base-button",
        {
          staticClass:
            "button--icon quantity-input__control quantity-input__control--decrement",
          attrs: { disabled: _vm.disableDecrement },
          on: { click: _vm.decrement }
        },
        [
          _c("div", { staticClass: "u-sr-only" }, [
            _vm._v("Decrease Quantity")
          ]),
          _c("icon", {
            attrs: { name: "minus", size: _vm.iconSize, height: "23px" }
          })
        ],
        1
      ),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue"
          }
        ],
        staticClass: "quantity-input__input",
        attrs: {
          type: "text",
          id: _vm.idForInput,
          name: _vm.name,
          min: _vm.min,
          max: _vm.max,
          placeholder: _vm.placeholder,
          readonly: "",
          tabindex: -1
        },
        domProps: { value: _vm.currentValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.currentValue = $event.target.value
          }
        }
      }),
      _c(
        "base-button",
        {
          staticClass:
            "button--icon quantity-input__control quantity-input__control--increment",
          attrs: { disabled: _vm.disableIncrement },
          on: { click: _vm.increment }
        },
        [
          _c("div", { staticClass: "u-sr-only" }, [
            _vm._v("Increase Quantity")
          ]),
          _c("icon", {
            attrs: { name: "plus", size: _vm.iconSize, height: "23px" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }